import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ConnectionService } from 'src/app/shared-services/connection.service';
import { environment } from 'src/environments/environment';
declare var $: any;

@Component({
    selector: 'app-submit-invoice',
    templateUrl: './submit-invoice.component.html',
    styleUrls: ['./submit-invoice.component.css']
})
export class SubmitInvoiceComponent implements OnInit {

    @Input() appId: any = 0;
    @Input() nextStep: any = '';

    @Output() reloadSlice = new EventEmitter<void>();
    
    public documents: any[] = [];

    public modalId = '';
    public messageTitle = '';
    public messageMessageA = '';
    public messageMessageB = '';
    public messageMessageC = '';
    public messageMessageAClass = '';
    public messageMessageBClass = '';
    public messageMessageCClass = '';
    public dialogClass = '';

    public uploadDocumentId = 'uploadDocumentId' + this.appId;

    constructor(private connectionService: ConnectionService) { }

    ngOnInit() {
        this.uploadDocumentId = 'uploadDocumentId' + this.appId;
        this.modalId = 'UploadDocumentModalId' + this.appId;
    }

    onFileAdded(file: any) {
        this.documents = [];
        this.documents.push(file);
    }

    onUploadInvoiceFile() {
        return new Promise((resolve, reject) => {
            const nachaFile = {
                documentB: this.documents[0].file.data.substr(this.documents[0].file.data.indexOf(',') + 1),
                name: this.documents[0].file.name
            };
            this.connectionService.postRequest(environment.gateway + 'application/' + this.appId + '/invoice', nachaFile,
                'application/json').subscribe(
                    (data: any) => {
                        this.messageTitle = 'Invoice Received';
                        this.messageMessageA = 'Invoice has been submitted and is under review for funding.';
                        this.messageMessageB = '';
                        this.messageMessageC = 'Approved invoices submitted by 5 pm eastern time should be funded the same day.';
                        this.messageMessageAClass = 'upload-success-a';
                        this.messageMessageBClass = 'upload-success-b';
                        this.messageMessageCClass = 'upload-success-c';
                        this.dialogClass = 'w650';
                        $('#errorModalDialogUploadDocumentModalId' + this.appId).modal();
                        this.documents = [];
                        resolve(data);
                    },
                    (error: any) => {
                        this.messageTitle = 'Sorry, we found a problem';
                        this.messageMessageA = 'Unfortunately we are unable to process your request at this moment.';
                        this.messageMessageB = error.error.msg;
                        this.messageMessageC = 'Please contact customer service at 1-888-509-5592 for more information.';
                        this.messageMessageAClass = '';
                        this.messageMessageBClass = 'mB20';
                        this.messageMessageCClass = '';
                        this.dialogClass = 'w600';
                        $('#errorModalDialogUploadDocumentModalId' + this.appId).modal();
                        this.documents = [];
                        resolve(error);
                    }
                );
        });
    }

    onCloseModal() {
        this.reloadSlice.emit();
        this.ngOnInit();
    }

}
